import * as React from 'react'

type CheckboxProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'checked'
> & {
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
}

export function Checkbox({
  className,
  checked,
  onCheckedChange,
  ...props
}: CheckboxProps) {
  return (
    <input
      type="checkbox"
      className={`h-4 w-4 rounded-sm border border-neutral-300 focus:ring-0 accent-brand-primary ${
        className || ''
      }`}
      checked={checked}
      onChange={(e) => onCheckedChange?.(e.target.checked)}
      {...props}
    />
  )
}
